import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'ANTEPRIMA',
        description:
            "Qui vedi il testo integrale dell'esercizio e la soluzione se presente. In alcuni casi, trovi il pulsante per modificarlo e crearne una tua versione.",
        isActive: true,
        name: 'Preview',
        tutorialName: 'crea-verifica_anteprima-esercizio-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 20,
        yOffset: 20
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 20,
        yOffset: 20
    },
    pages: ['#/search', '#/search/', '#/search/editorial', '#/search/editorial/']
};
